import { showHttpError } from '@calendly/alert'
import { httpRequest } from '@calendly/http-tools'

import { scopeDropdownSelector } from 'selectors/home_bar'

export const loadTitle = (scopeType, scopeId) => async (dispatch) => {
  dispatch({ type: 'SCOPE_DROPDOWN_TITLE_REQUEST' })

  const [success, responseData] = await httpRequest({
    url: '/api/event_types/scope_dropdown/current_scope',
    params: {
      current_scope: scopeType,
      owner_id: scopeId
    }
  })

  if (success) {
    dispatch({
      type: 'SCOPE_DROPDOWN_TITLE_RESPONSE',
      payload: responseData.current_scope
    })
  } else {
    dispatch(showHttpError(responseData))
  }
}

export const loadData = () => async (dispatch, getState) => {
  const scopeDropdown = scopeDropdownSelector(getState())
  if (scopeDropdown.data) return

  dispatch({ type: 'SCOPE_DROPDOWN_DATA_REQUEST' })

  const [success, responseData] = await httpRequest({
    url: '/api/event_types/scope_dropdown/all_scopes',
    params: {
      filter_term: scopeDropdown.filterTerm || undefined
    }
  })

  if (success) {
    dispatch({
      type: 'SCOPE_DROPDOWN_DATA_RESPONSE',
      payload: responseData
    })

    if (!scopeDropdown.filterTerm) {
      dispatch({
        type: 'SCOPE_DROPDOWN_ANY_USER_GROUPS',
        payload: responseData.user_groups.data.length > 0
      })
    }
  } else {
    dispatch(showHttpError(responseData))
  }
}
export const loadMoreData = (scope) => async (dispatch, getState) => {
  const scopeDropdown = scopeDropdownSelector(getState())

  const [success, responseData] = await httpRequest({
    url: `/api/event_types/scope_dropdown/${scope}`,
    params: {
      filter_term: scopeDropdown.filterTerm || undefined,
      page: scopeDropdown.data[scope].next_page
    }
  })

  if (success) {
    dispatch({
      type: 'SCOPE_DROPDOWN_MORE_DATA_RESPONSE',
      payload: {
        data: responseData,
        scope
      }
    })
  } else {
    dispatch(showHttpError(responseData))
  }
}

export const resetData = () => ({ type: 'SCOPE_DROPDOWN_RESET_DATA' })

export const filterResults = (filterTerm) => (dispatch) => {
  dispatch({
    type: 'SCOPE_DROPDOWN_UPDATE_FILTER_TERM',
    payload: filterTerm
  })
  dispatch(resetData())
  dispatch(loadData())
}

export const triggerExpand = () => ({ type: 'SCOPE_DROPDOWN_FORCE_EXPAND_TRIGGERED', payload: true })
export const resetTriggerExpand = () => ({ type: 'SCOPE_DROPDOWN_FORCE_EXPAND_TRIGGERED', payload: false })
